
import { useEffect } from 'react'

import { Flex } from '@chakra-ui/react';

import DataTable from 'views/privado/servicesPostsales/reporteGastos/components/DataTable'; 

import { useHistory } from "react-router-dom";
import useAuthContext from "hooks/useAuthContext";

import { LAYOUT_PUBLICO, PATH_LOGIN } from "const/CommonConst";


export default function ReporteGastos() {	
	useEffect(() => document.title = `Taurel - Servicios en Línea - Reporte de Gastos`,[]);
	
	const history = useHistory();

	const {isAuthenticate, checkExpired, logout} = useAuthContext();
  
	useEffect(async () => {
	  if (!isAuthenticate || await checkExpired()){
		  logout();
		  history.push(`${LAYOUT_PUBLICO}${PATH_LOGIN}`);
	  }
	}, []); 
	
	return (
		<Flex direction='column' pt={{ sm: '125px', lg: '75px' }}>
			<DataTable  />
		</Flex>
	);
}
